import { Section } from './Section.jsx';
import { THEMES } from '../../lib/theme.js';
import { T } from '../T.jsx';

// Longer blurbs than the nav dropdown's, with their own i18n keys — the two
// lists are not interchangeable, so these live here rather than in lib/theme.js.
const PREVIEW_DESCRIPTIONS = {
  cosmic:   ['ml_theme_cosmic_desc',   'Dark, vibrant neon — bold and modern'],
  daylight: ['ml_theme_daylight_desc', 'Bright, clean, and colorful'],
  oxford:   ['ml_theme_oxford_desc',   'Dark navy with gold accents'],
  ivory:    ['ml_theme_ivory_desc',    'Warm academic, serious tone'],
  slate:    ['ml_theme_slate_desc',    'Minimal, corporate clean'],
  polyu:    ['ml_theme_polyu_desc',    'Brick red, institutional'],
};

export function ThemesDemo({ onChoose }) {
  return (
    <Section>
      <section className="section" id="themes-demo">
        <T k="ml_themes_label" className="section-label">Themes</T>
        <T k="ml_themes_heading" as="h2" className="section-heading fade-in">
          Beautiful Themes, Your Choice
        </T>
        <T k="ml_themes_intro" as="p" className="section-intro fade-in">
          Choose from six professionally designed themes that adapt every element of
          your presentation. Click any theme below to preview it live.
        </T>
        <div className="themes-grid">
          {THEMES.map((theme) => {
            const [descKey, desc] = PREVIEW_DESCRIPTIONS[theme.id];
            return (
              <button
                key={theme.id}
                className="theme-preview-card fade-in"
                data-preview-theme={theme.id}
                onClick={() => onChoose(theme.id)}
              >
                <div className="theme-preview-swatch">
                  {theme.swatch.map((c) => (
                    <span key={c} style={{ background: c }} />
                  ))}
                </div>
                {/* The theme name is a proper noun and was never translated. */}
                <h4>{theme.name}</h4>
                <T k={descKey} as="p">{desc}</T>
              </button>
            );
          })}
        </div>
      </section>
    </Section>
  );
}
